import { createContext } from 'react';
import { dayjs } from 'lib/dayjs';
import { ReportPerformanceParams } from 'queries/performance';
import { PerformanceEvent } from './types';

export const REPORT_TYPE_OIL_PRODUCTION = 'Performance Report - Oil Production Efficiency';
export const REPORT_TYPE_PRODUCED_WATER = 'Performance Report - Produced Water';
export const REPORT_TYPE_GAS_DEHYDRATION = 'Performance Report - Gas Dehydration';
export const REPORT_TYPE_IUGA = 'Performance Report - IUGA';
export const DAY_TO_SPLIT_MONTH = 26;

export interface PerformanceState {
  events?: PerformanceEvent[];
  isLoading: boolean;
  refetch: () => void;
  reportParams?: ReportPerformanceParams;
  setReportParams: (reportParams: ReportPerformanceParams) => void;
}

const defaultPerformanceState = {
  events: [],
  isLoading: false,
  refetch: () => null,
  reportParams: undefined,
  setReportParams: () => null,
};

export const getDefaultParams = () => {
  const today = dayjs();
  const initialDate = today.get('D') >= DAY_TO_SPLIT_MONTH ? today.add(1, 'M') : today;

  return {
    vesselId: '',
    reportType: REPORT_TYPE_OIL_PRODUCTION,
    month: initialDate.toDate().getMonth() + 1,
    year: initialDate.toDate().getFullYear(),
  };
};

export const PerformanceContext = createContext<PerformanceState>(defaultPerformanceState);
